import { Controller } from "stimulus"
import $ from "jquery"
import {
  parseLeadCaptureFromForm,
  openLeadCaptureModal,
  shouldSkipLeadCaptureModal,
  applyStoredLeadCaptureAnswersToForm,
  bindStoredLeadCaptureToForm
} from "./lead_capture_modal_utils"

export default class extends Controller {
  static targets = [ "selector", "submitter", "planPrice", "planId", "periodId", "servicePlan", "setupFee", "plan", "serviceTypeSelector", "servicePeriodSelector", "servicePeriodButton", "serviceTypeTab", "serviceType", "canCommercial", "canResidential", "addOnModal" ]

  connect() {
    // Remember the user's last explicit add-on checkbox state so toggling between plans with
    // different required add-ons can restore what they previously chose.
    this._userAddOnState = {}
    let initialPlanElement = $(this.selectorTarget).find('input:checked')
    this.planElement = initialPlanElement
    this.toggle()
    if (this.hasSubmitterTarget) bindStoredLeadCaptureToForm(this.submitterTarget.closest("form"))
  }

  submitOrShowModal(event) {
    event.preventDefault()
    const form = this.submitterTarget.closest("form")
    this.runAfterAddOnModalIfNeeded(form, () => {
      this.withLeadCapture(form, () => form.submit())
    })
  }

  /** Primary action on service add-on modal: close it, then lead capture (if any) and form submit. */
  confirmServiceAddOnModal(event) {
    event.preventDefault()
    event.stopPropagation()
    const form = this.submitterTarget.closest("form")
    $(this.addOnModalTarget).modal("hide")
    this.withLeadCapture(form, () => form.submit())
  }

  /**
   * If modal add-ons exist, show that modal first; otherwise run immediately.
   * Continuation runs after user confirms the add-on modal (button is type=button).
   */
  runAfterAddOnModalIfNeeded(form, afterAddons) {
    const hasModalAddOns =
      this.hasAddOnModalTarget &&
      this.addOnModalTarget &&
      this.addOnModalTarget.querySelectorAll('input[type="checkbox"],input[type="radio"]').length > 0

    if (hasModalAddOns) {
      $(this.addOnModalTarget).modal("show")
    } else {
      afterAddons()
    }
  }

  withLeadCapture(form, runNext) {
    const full = parseLeadCaptureFromForm(form)
    const addressStatus = form.dataset.leadCaptureAddressStatus || ""
    const currentStep = form.dataset.leadCaptureCurrentStep || ""
    const addressId = form.dataset.leadCaptureAddressId || ""

    if (shouldSkipLeadCaptureModal(form, full, addressStatus, currentStep, addressId)) {
      try {
        applyStoredLeadCaptureAnswersToForm(form)
      } catch (_e) {
        // Cached answers must not stop plan selection.
      }
      runNext()
      return
    }

    if (!document.getElementById("leadCaptureEmailModal")) {
      runNext()
      return
    }

    const opened = openLeadCaptureModal({
      modalId: "leadCaptureEmailModal",
      full,
      addressStatus,
      addressId,
      currentStep,
      form,
      onConfirm: (email) => {
        const hidden = form.querySelector('input[name="accounts_sign_up[email]"]')
        if (hidden) hidden.value = email
        // how_heard / how_heard_other are written into the form by openLeadCaptureModal
        // (via writeHowHeardToForm) before this callback fires, so submit picks them up.
        runNext()
      }
    })
    if (!opened) runNext()
  }

  toggle(event) {

    const selectedServiceType = this.serviceTypeSelectorTarget.querySelector("input[type='radio']:checked");
    const selectedServicePeriod = this.servicePeriodSelectorTarget.querySelector("input[type='radio']:checked");


    // Remove 'active' class from all buttons in the group
    this.servicePeriodButtonTargets.forEach(button => {
       button.classList.remove("active");
    });

    this.serviceTypeTabTargets.forEach(button => {
      button.classList.remove("active");
    });

    selectedServiceType.closest('label.nav-link').classList.add("active");
    selectedServicePeriod.closest('.btn').classList.add("active");

    // // Hide/Show plans based on selected period
    this.planTargets.forEach((plan) => {
       console.log(plan.dataset.period, selectedServicePeriod.value, plan.dataset.type, selectedServiceType.value)
       plan.style.display = (plan.dataset.period === selectedServicePeriod.value && plan.dataset.type === selectedServiceType.value ? "block" : "none")
    });
  }

  selectServicePlan(event) {
    let planElement = $(event.target);
    this.planElement = planElement
  }

  get planElement() {
    return this.data.get('selectedPlan')
  }

  set planElement(planElement) {
    console.log(planElement)
    planElement = $(planElement);
    let selectedPlan = planElement.attr('data-service-plan');
    let planPrice    = planElement.attr('data-plan-price');
    let planId       = planElement.attr('data-plan-id');
    let periodId     = planElement.attr('data-period-id');
    let setupFee     = planElement.attr('data-setup-fee');
    let serviceType  = planElement.attr('data-service-type');

    this.data.set('selectedPlan', selectedPlan)
    this.data.set('planPrice',    planPrice)
    this.data.set('planId',       planId)
    this.data.set('setupFee',     setupFee)

    if (selectedPlan) {
      $(this.submitterTarget).removeAttr("disabled")
      $(this.planPriceTarget).val(planPrice)
      $(this.periodIdTarget).val(periodId)
      $(this.planIdTarget).val(planId)
      $(this.setupFeeTarget).val(setupFee)
      $(this.servicePlanTarget).val(selectedPlan)
      $(this.serviceTypeTarget).val(serviceType)
      $(this.canCommercialTarget).val(serviceType=='commercial')
      $(this.canResidentialTarget).val(serviceType=='residential')
    } else {
      $(this.submitterTarget).attr("disabled", true)
    }

    this.applyRequiredAddOns(planElement)
  }

  /**
   * Enforce required add-on surcharges for the selected plan. For each `.add-on` element with a
   * `data-uisp-surcharge-id`, if the selected plan's `data-required-surcharge-ids` JSON includes
   * that id we lock the first input (checkbox or the "yes" radio) as checked + disabled and show
   * the "Required" badge. Otherwise we restore the user's previous state. Safe no-op when the
   * data attributes are absent (non-opt-in tenants).
   */
  applyRequiredAddOns(planElement) {
    if (!planElement || planElement.length === 0) return

    let rawIds = planElement.attr('data-required-surcharge-ids')
    let requiredIds = []
    if (rawIds) {
      try {
        const parsed = JSON.parse(rawIds)
        if (Array.isArray(parsed)) requiredIds = parsed.map((v) => String(v))
      } catch (e) {
        console.warn('service_plan_controller: failed to parse data-required-surcharge-ids', e)
      }
    }

    const addOnContainers = document.querySelectorAll('.add-on[data-uisp-surcharge-id]')
    addOnContainers.forEach((container) => {
      const surchargeId = container.getAttribute('data-uisp-surcharge-id')
      if (!surchargeId) return

      const badge = container.querySelector('.required-add-on-badge')
      const primaryInput =
        container.querySelector('input[type="checkbox"]') ||
        container.querySelector('input[type="radio"][id$="_yes"]') ||
        container.querySelector('input[type="radio"]')
      const noInput = container.querySelector('input[type="radio"][id$="_no"]')
      if (!primaryInput) return

      const key = `${primaryInput.name}:${primaryInput.id}`
      const isRequired = requiredIds.includes(String(surchargeId))

      if (isRequired) {
        if (this._userAddOnState[key] === undefined) {
          this._userAddOnState[key] = primaryInput.checked
        }
        primaryInput.checked = true
        primaryInput.disabled = true
        if (noInput) {
          noInput.checked = false
          noInput.disabled = true
        }
        if (badge) badge.style.display = ''
      } else {
        if (this._userAddOnState[key] !== undefined) {
          primaryInput.checked = this._userAddOnState[key]
          delete this._userAddOnState[key]
        }
        primaryInput.disabled = false
        if (noInput) noInput.disabled = false
        if (badge) badge.style.display = 'none'
      }
    })
  }

  handleChoosePlanClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const input = event.target.closest('label').querySelector('input[type="radio"]')
    input.checked = true;
    console.log(input)
    this.planElement = input;
    const form = input.closest("form")
    this.runAfterAddOnModalIfNeeded(form, () => {
      this.withLeadCapture(form, () => { form.submit() })
    })
  }
}
